/**
 * @generated SignedSource<<0c551d801199c1fd14dce1f7f87e63cb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SortOrder = "ASC" | "DESC";
export type learnTrackingList_QueryFragmentRefetch$variables = {
  after?: string | null;
  before?: string | null;
  filterByCompletedCourses?: boolean | null;
  filterByGroupIds?: ReadonlyArray<string> | null;
  filterByMaxDate?: string | null;
  filterByMinDate?: string | null;
  filterByText?: string | null;
  first?: number | null;
  last?: number | null;
  sortByUserLastName?: SortOrder | null;
};
export type learnTrackingList_QueryFragmentRefetch$data = {
  readonly " $fragmentSpreads": FragmentRefs<"learnTrackingList_QueryFragment">;
};
export type learnTrackingList_QueryFragmentRefetch = {
  response: learnTrackingList_QueryFragmentRefetch$data;
  variables: learnTrackingList_QueryFragmentRefetch$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "before"
  },
  {
    "defaultValue": false,
    "kind": "LocalArgument",
    "name": "filterByCompletedCourses"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByGroupIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByMaxDate"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByMinDate"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterByText"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "first"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "last"
  },
  {
    "defaultValue": "ASC",
    "kind": "LocalArgument",
    "name": "sortByUserLastName"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "filterByCompletedCourses",
    "variableName": "filterByCompletedCourses"
  },
  {
    "kind": "Variable",
    "name": "filterByGroupIds",
    "variableName": "filterByGroupIds"
  },
  {
    "kind": "Variable",
    "name": "filterByMaxDate",
    "variableName": "filterByMaxDate"
  },
  {
    "kind": "Variable",
    "name": "filterByMinDate",
    "variableName": "filterByMinDate"
  },
  {
    "kind": "Variable",
    "name": "filterByText",
    "variableName": "filterByText"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "sortByUserLastName",
    "variableName": "sortByUserLastName"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "performanceInPercent",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalPoints",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "receivedPoints",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "learnTrackingList_QueryFragmentRefetch",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "FragmentSpread",
        "name": "learnTrackingList_QueryFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "learnTrackingList_QueryFragmentRefetch",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ViewerQueryType",
        "kind": "LinkedField",
        "name": "Viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "LearntrackingViewerSchema",
            "kind": "LinkedField",
            "name": "Learntracking",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": (v1/*: any*/),
                "concreteType": "LearnStatesForUserConnection",
                "kind": "LinkedField",
                "name": "learntracking",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LearnStatesForUserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LearnStatesForUser",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "userExtensionKind",
                                    "value": "Academies"
                                  }
                                ],
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "extension",
                                "plural": false,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "File",
                                        "kind": "LinkedField",
                                        "name": "avatar",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "thumbnail",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "url",
                                            "storageKey": null
                                          },
                                          (v3/*: any*/),
                                          (v2/*: any*/)
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "type": "AcademiesUserExtension",
                                    "abstractKey": null
                                  }
                                ],
                                "storageKey": "extension(userExtensionKind:\"Academies\")"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "averageProgressInPercent",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "LearnStates",
                            "kind": "LinkedField",
                            "name": "learnStates",
                            "plural": true,
                            "selections": [
                              (v5/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "startedAt",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "progressInPercent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PerformanceScores",
                                "kind": "LinkedField",
                                "name": "scores",
                                "plural": false,
                                "selections": [
                                  (v6/*: any*/),
                                  (v7/*: any*/),
                                  (v8/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ModuleStates",
                                "kind": "LinkedField",
                                "name": "moduleStates",
                                "plural": true,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lastEditedTitle",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "lastEditedAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "PerformanceScores",
                                    "kind": "LinkedField",
                                    "name": "scores",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v8/*: any*/),
                                      (v7/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v1/*: any*/),
                "filters": [
                  "sortByUserLastName",
                  "filterByText",
                  "filterByMinDate",
                  "filterByMaxDate",
                  "filterByGroupIds",
                  "filterByCompletedCourses"
                ],
                "handle": "connection",
                "key": "learnTrackingList_learntracking",
                "kind": "LinkedHandle",
                "name": "learntracking"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "16c0e5fe09d995a883da35fda70c2a53",
    "id": null,
    "metadata": {},
    "name": "learnTrackingList_QueryFragmentRefetch",
    "operationKind": "query",
    "text": "query learnTrackingList_QueryFragmentRefetch(\n  $after: String = null\n  $before: String = null\n  $filterByCompletedCourses: Boolean = false\n  $filterByGroupIds: [ID!] = null\n  $filterByMaxDate: LocalDate = null\n  $filterByMinDate: LocalDate = null\n  $filterByText: String = null\n  $first: Int = null\n  $last: Int = null\n  $sortByUserLastName: SortOrder = ASC\n) {\n  ...learnTrackingList_QueryFragment_137c5L\n}\n\nfragment learnStateProgressBar_LearnStatesFragment on LearnStates {\n  moduleStates {\n    title\n    lastEditedTitle\n    lastEditedAt\n    scores {\n      performanceInPercent\n      receivedPoints\n      totalPoints\n    }\n  }\n}\n\nfragment learnStateRow_LearnStatesFragment on LearnStates {\n  title\n  startedAt\n  progressInPercent\n  scores {\n    performanceInPercent\n    totalPoints\n    receivedPoints\n  }\n  ...learnStateProgressBar_LearnStatesFragment\n}\n\nfragment learnTrackingList_QueryFragment_137c5L on Query {\n  Viewer {\n    Learntracking {\n      learntracking(first: $first, last: $last, before: $before, after: $after, sortByUserLastName: $sortByUserLastName, filterByText: $filterByText, filterByMinDate: $filterByMinDate, filterByMaxDate: $filterByMaxDate, filterByGroupIds: $filterByGroupIds, filterByCompletedCourses: $filterByCompletedCourses) {\n        edges {\n          node {\n            ...learnTrackingRow_LearnStatesForUserFragment\n            learnStates {\n              title\n            }\n            user {\n              id\n            }\n            __typename\n          }\n          cursor\n        }\n        pageInfo {\n          hasNextPage\n          endCursor\n          hasPreviousPage\n          startCursor\n        }\n      }\n    }\n  }\n}\n\nfragment learnTrackingRow_LearnStatesForUserFragment on LearnStatesForUser {\n  user {\n    id\n    name\n    extension(userExtensionKind: Academies) {\n      __typename\n      ... on AcademiesUserExtension {\n        avatar {\n          thumbnail\n          url\n          name\n          id\n        }\n      }\n    }\n  }\n  averageProgressInPercent\n  learnStates {\n    title\n    ...learnStateRow_LearnStatesFragment\n  }\n}\n"
  }
};
})();

(node as any).hash = "0621a87f003a49e33cf2f8d883e398c9";

export default node;
